import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
import moment from "moment";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import ItemWhTable from "../../../components/Content/ItemWhTable";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";
import { whDocMasterModel } from "../../../../model/Warehouse/WHDocMasterModel";
import { whDocDetailModel } from "../../../../model/Warehouse/WHDocDetailModel";
import { getData } from "../../../../utils/SamuiUtils";
import {
  getDataWithComp,
  formatCurrency,
  getAlert,
  deleteData,
  randomDelay,
  parseCurrency,
  getSpRunNumber,
} from "../../../../utils/SamuiUtils";
import {
  formatDateTime,
  formatThaiDateUiToDate,
  setCreateDateTime,
  formatDate,
} from "../../../../utils/DateUtils";
import { manageWhItemData } from "../../../../utils/WarehouseUtils";

const Form = ({ callInitialize, mode, setMode, name, whDocNo }) => {
  const [formMasterList, setFormMasterList] = useState(whDocMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [selectedWarehouseFrom, setSelectedWarehouseFrom] = useState(null);
  const [dlLineName, setDlLineName] = useState("ไม่ระบุสายส่ง");
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showArModal, setShowArModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      if (mode === "U") {
        await getModelByNo(arDataList);
      }

      if (localStorage.getItem("company") === "2") {
        await handleChangeWarehouse("66");
      }
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล");
    }
  };

  const fetchAttachedFiles = async (whDocId) => {
    try {
      const attachedFiles = await getDataWithComp(
        "Upload_File_List",
        `AND Doc_Id = ${whDocId} AND DocCode_Id = 6`
      );
      if (attachedFiles && attachedFiles.length > 0) {
        const formattedFiles = attachedFiles.map((file) => ({
          F_Id: file.File_Id,
          fileName: file.File_Name,
          File_Url: file.File_Url,
          uploadDate: file.Upload_Date,
          uploadBy: file.Upload_By,
        }));
        setSelectedFiles(formattedFiles);
      } else {
        setSelectedFiles([]);
      }
    } catch (error) {
      console.error("Error fetching attached files:", error);
      setSelectedFiles([]);
      getAlert("FAILED", "ไม่สามารถดึงไฟล์แนบได้");
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      const fromDatabase = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_No = '${whDocNo}'`
      );
      if (!fromDatabase || fromDatabase.length === 0) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      await fetchAttachedFiles(fromDatabase[0].WHDoc_Id);

      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0].WHDoc_Cust_Id
      );
      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      await findDeliveryLineNameById(fromDatabase[0].WHDoc_Cust_Id);

      const getOnHand = async (whId, itemId) => {
        const itemOnHand = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
            itemId
          )}`
        );
        return itemOnHand[0]?.Item_Onhand || 0;
      };

      const createNewRow = (index, itemSelected, itemOnHand) => {
        return {
          ...whDocDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          whDocId: itemSelected.WHDoc_Id || null,
          line: itemSelected.Line || null,
          itemId: itemSelected.Item_Id || null,
          itemCode: itemSelected.Item_Code || null,
          itemName: itemSelected.Item_Name || null,
          itemOnHand: itemOnHand || null,
          itemQty: itemSelected.Item_Qty
            ? formatCurrency(itemSelected.Item_Qty)
            : null,
          itemIncrease: null,
          itemDecrease: itemSelected.Item_Qty || null,
          itemOrder: null,
          itemBalance:
            parseCurrency(itemOnHand) - parseCurrency(itemSelected.Item_Qty),
          itemUnit: itemSelected.Item_Unit || null,
          itemPriceUnit: itemSelected.Item_Price_Unit || null,
          itemDiscount: null,
          itemDisType: null,
          itemTotal: itemSelected.Item_Total || null,
          docType: itemSelected.Doc_Type || null,
          refDocId: itemSelected.Ref_DocID || null,
          refDocNo: itemSelected.Ref_DocNo || null,
          itemIsReturn: parseCurrency(itemSelected.Item_Is_Return) || 0,
          itemReturnDate: formatDate(itemSelected.Item_Return_Date) || null,
        };
      };

      const fromDetail = await getDataWithComp(
        "API_1002_WHDOC_D",
        `AND WHDoc_Id = ${fromDatabase[0].WHDoc_Id} AND Item_Is_Return <> 1 ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const itemOnHandPromises = fromDetail.map((item) =>
          getOnHand(fromDatabase[0].F_WH_Id, item.Item_Id)
        );
        const itemOnHandResults = await Promise.all(itemOnHandPromises);
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(
            formDetailList.length + index,
            item,
            itemOnHandResults[index]
          )
        );

        await handleChangeWarehouse(String(fromDatabase[0].F_WH_Id));

        setFormDetailList(newFormDetails);

        const data = fromDatabase[0];
        setFormMasterList({
          whDocId: data.WHDoc_Id,
          whDocNo: data.WHDoc_No,
          whDocType: data.WHDoc_Type,
          whDocCustId: data.WHDoc_Cust_Id,
          whDocCustCode: fromViewAr.AR_Code,
          whDocCustName: fromViewAr.AR_Name,
          whDocDate: data.WHDoc_Date,
          whDocTransDate: data.WHDoc_TransDate,
          whDocCreatedDate: setCreateDateTime(data.WHDoc_CreatedDate),
          whDocCreatedBy: data.WHDoc_CreatedBy,
          whDocStatus: data.WHDoc_Status,
          whDocSeq: data.WHDoc_SEQ,
          whDocRemark: data.WHDoc_Remark,
          whDocCompId: data.Comp_Id,
          whDocShowFront: data.WHDoc_ShowFront,
          refDocId: data.Ref_DocID,
          refDoc: null,
          refDocDate: null,
        });
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase[0].WHDoc_No}`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
    }
  };

  const handleUploadAttachments = async (whDocId) => {
    const pendingFiles = selectedFiles.filter((file) => file.isPending);
    if (pendingFiles.length === 0) {
      getAlert("OK", "ไม่มีไฟล์ใหม่ที่ต้องอัปโหลด");
      return;
    }

    try {
      // ใช้ dataUrl ที่มีอยู่แล้วจาก selectedFiles
      const filesWithBase64 = pendingFiles.map((file) => {
        if (!file.dataUrl) {
          throw new Error(`ไฟล์ ${file.name} ไม่มี dataUrl`);
        }
        return {
          id: file.id,
          name: file.name,
          type: file.type,
          size: file.size,
          dataUrl: file.dataUrl, // ใช้ property 'dataUrl' แทน 'data'
          isPending: true,
          displayName: file.name,
        };
      });

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload-file`,
        {
          comp_id: window.localStorage.getItem("company"),
          doc_id: whDocId,
          DocCode_ID: 6,
          upload_by: localStorage.getItem("username") || "system",
          file_status: "Y",
          files: filesWithBase64,
          doc_no_ref: null,
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        // อัปเดต selectedFiles เพื่อลบไฟล์ที่รออัปโหลด (isPending)
        setSelectedFiles((prev) =>
          prev
            .filter((file) => !file.isPending)
            .concat(
              response.data.files.map((file) => ({
                F_Id: file.File_Id,
                fileName: file.fileName,
                File_Url: file.fileUrl,
                uploadDate: file.uploadDate,
                uploadBy: file.uploadBy,
              }))
            )
        );
        await fetchAttachedFiles(whDocId);
        getAlert("OK", "อัปโหลดไฟล์สำเร็จ");
      } else {
        throw new Error(response.data.message || "การอัปโหลดล้มเหลว");
      }
    } catch (error) {
      console.error("Error uploading attachments:", error);
      //getAlert("FAILED", `การอัปโหลดล้มเหลว: ${error.message}`);
    }
  };

  const handleBeforeUploadAttach = () => {
    setOpenUploadAttach(true); // เปิด FileModal เพื่อเลือกไฟล์
  };

  const handleRemoveImage = (index) => {
    // Handled by FileModal's handleConfirmDelete
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  const handleChangeWarehouse = async (value) => {
    if (mode === "I") {
      setFormDetailList([]);
    }

    const itemDataList = await getDataWithComp(
      "Tb_Set_Item",
      `AND Item_Group IN ('5','15') AND Item_Status = 'Y' ORDER BY Item_Code ASC`
    );

    if (itemDataList && itemDataList.length > 0) {
      setItemDataList(itemDataList);
    }

    const itemOnHandList = await getDataWithComp(
      "API_1101_WH_ITEM_ONHAND",
      `AND WH_Id = ${parseCurrency(value)} ORDER BY Item_Code ASC`
    );

    if (
      itemOnHandList &&
      itemOnHandList.length > 0 &&
      itemDataList &&
      itemDataList.length > 0
    ) {
      const filteredItemOnHandList = itemOnHandList.filter((itemOnHand) =>
        itemDataList.some((itemData) => itemData.Item_Id === itemOnHand.Item_Id)
      );
      setItemDataList(filteredItemOnHandList);
    }

    setSelectedWarehouseFrom(value);
  };

  const handleQuantityChange = (index, type, value, onHand) => {
    if (type !== "decrease") {
      getAlert("FAILED", "พบข้อผิดพลาดในการดำเนินการ กรุณารีเฟรชแล้วลองใหม่");
      return;
    }

    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    if (value === ".") {
      const updatedList = [...formDetailList];
      updatedList[index].itemDecrease = value;
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    const updatedList = [...formDetailList];

    if (parseFloat(value) > onHand) {
      getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินคงเหลือ");
      updatedList[index].itemDecrease = null;
      updatedList[index].docType = "AO";
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    updatedList[index].docType = "AO";
    updatedList[index].itemDecrease = value;
    updatedList[index].itemQty = parseCurrency(value);
    updatedList[index].itemBalance =
      parseCurrency(onHand) - parseCurrency(value);

    setFormDetailList(updatedList);
  };

  const handleFocus = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease =
      parseCurrency(updatedList[index].itemQty) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = formatCurrency(
      updatedList[index].itemQty
    );
    setFormDetailList(updatedList);
  };

  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = async (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        whDocCustId: arSelected.AR_Id,
        whDocCustCode: arSelected.AR_Code,
        whDocCustName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      await findDeliveryLineNameById(arSelected.AR_Id);
      handleArClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => itemsSelected.find((item) => item.Item_Id === id));

      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        const existingItem = formDetailList.find(
          (item) => item.itemId === itemSelected.Item_Id
        );

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: existingItem
            ? formatCurrency(existingItem.itemQty || 0)
            : formatCurrency(1),
          itemDecrease: existingItem
            ? formatCurrency(existingItem.itemDecrease || 0)
            : formatCurrency(1),
          itemUnit: existingItem
            ? existingItem.itemUnit
            : itemSelected.Item_Unit_ST,
          itemPriceUnit: existingItem
            ? existingItem.itemPriceUnit
            : formatCurrency(itemSelected.Item_Cost || 0),
          itemOnHand: existingItem
            ? existingItem.itemOnHand
            : formatCurrency(itemSelected.Item_Onhand || 0),
          itemBalance: existingItem
            ? existingItem.itemBalance
            : formatCurrency(itemSelected.Item_Onhand - formatCurrency(1) || 0),
          itemTotal: existingItem ? existingItem.itemTotal : 0,
          docType: "AO",
          itemIsReturn: 0,
          itemReturnDate: moment()
            .utcOffset(7, true)
            .format("YYYY-MM-DD HH:mm:ss.SSS"),
        };
      });

      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };

  const findDeliveryLineNameById = async (arId) => {
    const deliveryLine = await getDataWithComp(
      "View_DL_Line",
      `AND DL_AR_Id = ${arId}`
    );
    if (deliveryLine && deliveryLine.length > 0) {
      setDlLineName(deliveryLine[0].DL_LineName);
    }
  };

  const handleSubmit = async () => {
    try {
      await randomDelay();
      const newMaxIb = await getSpRunNumber("IB");
      if (!newMaxIb) {
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }

      if (formMasterList.whDocCustId === null) {
        getAlert("FAILED", "กรุณาเลือกไปลูกค้า");
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะยืม");
        return;
      }

      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert(
            "FAILED",
            `กรุณากรอกจำนวนยืมของลังน้ำแข็ง : ${item.itemName}`
          );
          return;
        }
      }

      const formMasterData = {
        wh_doc_no: newMaxIb,
        wh_doc_type: parseCurrency("6", 10),
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formMasterList.whDocDate,
        wh_doc_trans_date: formMasterList.whDocTransDate,
        wh_doc_created_date: formatThaiDateUiToDate(
          formMasterList.whDocCreatedDate
        ),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: parseCurrency("1", 10),
        wh_doc_seq: formatDateTime(new Date()),
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: null,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wh_id: parseCurrency(formMasterList.whDocCustId, 10),
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId,
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        let whDocId =
          response.data.whDocId ||
          (await getDataWithComp("WHDoc_H", `AND WHDoc_No = '${newMaxIb}'`))[0]
            ?.WHDoc_Id;

        if (whDocId && selectedFiles.some((file) => file.isPending)) {
          await handleUploadAttachments(whDocId);
        }

        let line = 1;
        for (const item of formDetailList) {
          const formDetailData = {
            wh_doc_id: whDocId,
            line: line,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_total: parseCurrency(item.itemTotal),
            doc_type: item.docType,
            ref_doc_id: item.refDocId,
            item_is_return: item.itemIsReturn,
            item_return_date: item.itemReturnDate,
          };
          line++;

          await manageWhItemData(
            item.itemId,
            item.itemCode,
            item.itemName,
            selectedWarehouseFrom,
            "AO",
            parseCurrency(item.itemQty),
            whDocId,
            newMaxIb,
            newMaxIb,
            `ยืมสินค้า`
          );

          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        }

        callInitialize();
        setMode("S");
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }

      if (formMasterList.whDocCustId === null) {
        getAlert("FAILED", "กรุณาเลือกไปลูกค้า");
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะยืม");
        return;
      }

      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert(
            "FAILED",
            `กรุณากรอกจำนวนยืมของลังน้ำแข็ง : ${item.itemName}`
          );
          return;
        }
      }

      const formMasterData = {
        wh_doc_no: formMasterList.whDocNo,
        wh_doc_type: formMasterList.whDocType,
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formMasterList.whDocDate,
        wh_doc_trans_date: formMasterList.whDocTransDate,
        wh_doc_created_date: formatThaiDateUiToDate(
          formMasterList.whDocCreatedDate
        ),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: formMasterList.whDocStatus,
        wh_doc_seq: formMasterList.whDocSeq,
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: formMasterList.whDocShowFront,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wh_id: parseCurrency(formMasterList.whDocCustId, 10),
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId,
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const findOldIcebox = await getData(
          "API_1002_WHDOC_D",
          `WHDoc_Id = ${formMasterList.whDocId}`
        );

        if (findOldIcebox && findOldIcebox.length > 0) {
          for (const iceboxData of findOldIcebox) {
            await manageWhItemData(
              iceboxData.Item_Id,
              iceboxData.Item_Code,
              iceboxData.Item_Name,
              iceboxData.F_WH_Id,
              "AI",
              parseCurrency(iceboxData.Item_Qty),
              iceboxData.WHDoc_Id,
              formMasterList.whDocNo,
              formMasterList.whDocNo,
              `แก้ไขใบ : ${formMasterList.whDocNo}`
            );
          }
        }

        await deleteData(
          "WHDoc_D",
          `WHERE WHDoc_Id = ${formMasterList.whDocId}`
        );

        if (selectedFiles.some((file) => file.isPending)) {
          await handleUploadAttachments(formMasterList.whDocId);
        }

        let line = 1;
        for (const item of formDetailList) {
          const formDetailData = {
            wh_doc_id: formMasterList.whDocId,
            line: line,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_total: parseCurrency(item.itemTotal),
            doc_type: item.docType,
            ref_doc_id: item.refDocId,
            item_is_return: item.itemIsReturn,
            item_return_date: item.itemReturnDate,
          };
          line++;

          await manageWhItemData(
            item.itemId,
            item.itemCode,
            item.itemName,
            selectedWarehouseFrom,
            "AO",
            parseCurrency(item.itemQty),
            formMasterList.whDocId,
            formMasterList.whDocNo,
            formMasterList.whDocNo,
            `ยืมสินค้า`
          );

          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        }

        callInitialize();
        setMode("S");
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      const formMasterData = {
        wh_doc_no: formMasterList.whDocNo,
        wh_doc_status: parseCurrency("13", 10),
        comp_id: window.localStorage.getItem("company"),
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const findOldIcebox = await getData(
          "API_1002_WHDOC_D",
          `WHDoc_Id = ${formMasterList.whDocId}`
        );
        if (findOldIcebox && findOldIcebox.length > 0) {
          for (const iceboxData of findOldIcebox) {
            await manageWhItemData(
              iceboxData.Item_Id,
              iceboxData.Item_Code,
              iceboxData.Item_Name,
              iceboxData.F_WH_Id,
              "AI",
              parseCurrency(iceboxData.Item_Qty),
              iceboxData.WHDoc_Id,
              formMasterList.whDocNo,
              formMasterList.whDocNo,
              `ยกเลิกใบ : ${formMasterList.whDocNo}`
            );
          }
        }
        callInitialize();
        setMode("S");
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={whDocNo}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: name, url: "/icebox" },
          { name: mode === "U" ? `เรียกดู${name}` : `สร้าง${name}`, url: "#" },
        ]}
        isShowStatus={false}
        statusName={null}
        statusColour={null}
        otherStatusName={null}
        otherStatusColour={null}
        otherTypeName={null}
        otherTypeColour={null}
        docStatusForClosePK={null}
        docIsINV={null}
        onHandleClick={() => {}}
        onHandlePayslip={() => {}}
        onHandleCloseForWarehouse={() => {}}
        onHandleCloseForAccount={() => {}}
        onHandleInvoice1={() => {}}
        onHandleInvoice2={() => {}}
        onHandleInvoice3={() => {}}
        urlImg={null}
        handleUploadSlip={() => {}}
        base64Image={null}
        setBase64Image={() => {}}
        handleUpdateSlip={() => {}}
        docInvNo={null}
        isVatChecked={false}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        selectedRecFiles={[]}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={() => {}}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
      />

      <div className="body">
        <div className="container-fluid my-4">
          <div className="row mb-1">
            <div className="col-4">
              <DatePicker
                label="วันที่เอกสาร"
                name="whDocDate"
                value={formMasterList.whDocDate}
                onChange={(date) => handleChangeDateMaster(date, "whDocDate")}
                disabled={mode === "U"}
              />
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>จากคลัง : </label>
                <select
                  className="form-select"
                  value={selectedWarehouseFrom}
                  disabled={mode === "U"}
                  onChange={(e) => handleChangeWarehouse(e.target.value)}
                >
                  <option value={null}>กรุณาระบุคลัง</option>
                  {whDataList.map((warehouse) => (
                    <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                      {warehouse.WH_Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>สร้างโดย : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.whDocCreatedBy}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-4">
              <DatePicker
                label="วันที่จัดส่ง"
                name="whDocTransDate"
                value={formMasterList.whDocTransDate}
                onChange={(date) =>
                  handleChangeDateMaster(date, "whDocTransDate")
                }
                disabled={formMasterList.refDocId !== null}
              />
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>ไปที่ลูกค้า :</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apCode"
                    value={`${formMasterList.whDocCustCode || ""} ${
                      formMasterList.whDocCustName || ""
                    }`}
                    onChange={handleChangeMaster}
                    disabled
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleArShow}
                    disabled={mode === "U"}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                <ArModal
                  showArModal={showArModal}
                  handleArClose={handleArClose}
                  arDataList={arDataList}
                  onRowSelectAr={onRowSelectAr}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>วันที่สร้าง : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.whDocCreatedDate}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>หมายเหตุ : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="whDocRemark"
                  value={formMasterList.whDocRemark || ""}
                  onChange={handleChangeMaster}
                  disabled={formMasterList.refDocId !== null}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex align-items-center">
                <label>สายส่ง</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={dlLineName || "ไม่ระบุสายส่ง"}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>

      <div className="container-fluid my-3">
        <div className="row">
          <div className="col-12">
            <ItemWhTable
              mode={mode}
              showItemModal={showItemModal}
              handleItemClose={handleItemClose}
              itemDataList={itemDataList}
              onRowSelectItem={onRowSelectItem}
              formDetailList={formDetailList}
              handleItemShow={handleItemShow}
              handleQuantityChange={handleQuantityChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleRemoveRow={handleRemoveRow}
              formatCurrency={formatCurrency}
              disabled={selectedWarehouseFrom === null}
            />
            <FormAction
              onSubmit={handleSubmit}
              onUpdate={handleUpdate}
              onCancel={handleCancel}
              mode={mode}
              setMode={setMode}
              disabled={formMasterList.refDocId !== null}
              footer={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
